import { Message } from 'primereact/message';
import styled from 'styled-components';

export const VideoFallbackMessage = styled(Message)`
  background: #ecf5fc !important;
  border: 1px solid var(--blue-opacity);

  &.p-inline-message .p-inline-message-icon {
    color: var(--blue-dark);
    align-self: flex-start;
    margin-top: 2px;
  }
`;
